module.exports = __webpack_public_path__ + "static/media/tango.e964d616.png";